import React from "react";

import SquareLoader from "react-spinners/SquareLoader";

import useTheme from "@styles/useTheme";
import { CircularProgress } from "@libraries/mui";
import * as Styled from "./styles";

interface LoadingProps {
  loading?: boolean;
}

const Loading: React.FC<LoadingProps> = ({ loading }) => {
  if (!loading) return null;

  return (
    <Styled.Container id="loading-container">
      <CircularProgress />
    </Styled.Container>
  );
};

Loading.defaultProps = {
  loading: true
};

export default Loading;
